export enum StatusColorEnum {
  GREY = 'grey',
  WHITE = '#F2F2F2',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  GREEN = 'green',
  BLUE = 'blue',
  BLACK = 'black',
  RED = 'red',
}
